import { render } from "./subPostDelete.vue?vue&type=template&id=120ba665"
import script from "./subPostDelete.vue?vue&type=script&lang=js"
export * from "./subPostDelete.vue?vue&type=script&lang=js"
script.render = render

export default script